import { IGetValueArgs } from "@components/smart/FieldInfo";

export const isNewEntity = (args: IGetValueArgs): boolean => {
    return args.storage.data.bindingContext.isNew();
};

export const isPayrollEnabled = (args: IGetValueArgs): boolean => {
    return args.context.isPayrollEnabledOnCurrentAgenda();
};